<template>
  <NoContent
    v-if="modelValue.placeholder"
    :title="modelValue.placeholder.title"
    :description="modelValue.placeholder.description"
    :icon="$options.noUsersImage"
  />
  <PaginatedResource
    v-else
    v-model="friendsModel"
    :action="action"
    :params="params"
  >
    <WithPagination scroll-to-top>
      <SeparatedList
        :items="modelValue.list"
        v-slot="{ item }"
      >
        <UserListItem :user="item">
          <template #aside>
            <FriendshipButton
              v-if="item.friendship"
              v-model="item.friendship"
              :user-id="item.id"
            />
          </template>
        </UserListItem>
      </SeparatedList>
    </WithPagination>
  </PaginatedResource>
</template>

<script>
  import { PersonalResource } from 'src/services/personal.js';
  import { createPropModel, modelValueConfig } from 'src/utils/vue.js';

  import FriendshipButton from 'src/components/buttons/FriendshipButton/FriendshipButton.vue';
  import PaginatedResource from 'src/components/pagination/PaginatedResource/PaginatedResource.vue';
  import WithPagination from 'src/components/pagination/WithPagination/WithPagination.vue';
  import NoContent from 'src/components/placeholders/NoContent/NoContent.vue';
  import SeparatedList from 'src/components/SeparatedList/SeparatedList.vue';
  import UserListItem from 'src/components/users/UserListItem/UserListItem.vue';

  import noUsersImage from 'images/no_content.icon.user.png';
  
  export default {
    name: 'UserFriendsList',
    components: { NoContent, UserListItem, FriendshipButton, SeparatedList, WithPagination, PaginatedResource },
    model: modelValueConfig(),
    noUsersImage: {
      src: noUsersImage,
      width: 92,
      height: 92,
    },
    props: {
      modelValue: {
        type: Object,
        required: true,
      },
      userId: {
        type: String,
        required: true,
      },
    },
    methods: {
      action: PersonalResource.getFriends,
    },
    computed: {
      params() {
        const { userId } = this;
        return { userId };
      },
      friendsModel: createPropModel('modelValue')
    }
  }
</script>